<template lang='pug'>
  i.svg-icon.svg-icon-ccoin
    svg(
      :width='`${size}px`'
      :height='`${size}px`'
      viewBox='0 0 100 100')

      circle(fill='#EFEFEF' cx='50.057' cy='50.066' r='44.409')
      path(fill-rule='evenodd' clip-rule='evenodd' fill='#E36256' d='M66.418,63.289c-0.29,0.089-0.58,0.187-0.876,0.274 c-4.065,1.229-8.203,1.724-12.387,0.896c-4.948-0.975-8.531-3.752-10.332-8.547c-0.715-1.912-1.016-3.873-1.017-5.847H24.084 c-0.017,1.905,0.119,3.83,0.438,5.767c1.778,10.904,8.092,17.87,18.679,20.872c7.195,2.043,14.465,1.626,21.7,0.081 c1.292-0.272,2.546-0.734,3.842-1.115c-0.699-4.229-1.372-8.31-2.042-12.36C66.526,63.295,66.466,63.274,66.418,63.289z')
      path(fill-rule='evenodd' clip-rule='evenodd' fill='#11979D' d='M41.754,50.066c-0.002-1.235,0.085-2.475,0.339-3.716 c1.046-5.191,4.018-8.806,9.104-10.529c3.458-1.174,6.986-0.967,10.503-0.381c1.461,0.246,2.893,0.713,4.397,1.095 c0.89-4.105,1.788-8.229,2.694-12.372c-0.272-0.11-0.451-0.189-0.634-0.248c-3.465-1.152-7.031-1.702-10.675-1.839 c-5.114-0.196-10.143,0.3-14.993,2.037c-7.156,2.563-12.594,7.086-15.817,14.057c-1.773,3.841-2.594,7.824-2.636,11.897H41.754z')

</template>

<script>
export default {

  props: {
    size: {
      type: Number,
      default: 20,
    },
    color: {
      type: String,
      default: '',
    },
  },
};

</script>
